<template>
  <div class="home">
    <a-row :gutter="16">
      <a-col :span="24">
        <a-card title="Kontakt">
          <a-row :gutter="16">
            <a-col
                :lg="0"
                :md="24"
                :sm="24"
                :xl="0"
                :xs="24"
                :xxl="0"
                style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <a-row type="flex">
                <a-page-header sub-title="Automatic Customer Support">
                  <template #title>
                    <a-avatar :size="32">
                      <img
                          slot="icon"
                          alt="Avatar"
                          src="@/assets/brain.png"
                      /></a-avatar
                    >
                    Brainy
                  </template>
                </a-page-header>
              </a-row
              >
            </a-col
            >
            <a-col
                :lg="18"
                :md="24"
                :sm="24"
                :xl="18"
                :xs="24"
                :xxl="18"
                class="v-divider"
                style="display: flex; height: 65vh; flex-direction: column"
            >
              <a-row
                  id="chat-container"
                  ref="chat"
                  style="
                  width: 100%;
                  align-self: auto;
                  flex-grow: 1;
                  overflow-x: hidden;
                  overflow-y: auto;
                "
              >
                <transition-group name="list" tag="div">
                  <Message
                      v-for="message in messages"
                      :key="message.id"
                      :author="message.author"
                      :content="message.content"
                      :date="message.date"
                      :mediaUrl="message.mediaUrl"
                      :mentionedMessage="
                      getMentionedMessage(message.mentionedMessage)
                    "
                      :messageId="message.id"
                      :side="message.side"
                      :type="message.type"
                      class="chat-message list-item"
                      @mention="mentionMessage"
                  />
                </transition-group>
                <div ref="end"></div>
              </a-row>
              <a-row style="width: 100%; align-self: flex-end">
                <p v-if="mentionedMessageId">
                  <strong>Odpowiadasz na wiadomość:</strong>&nbsp;{{
                    getMentionedMessage(mentionedMessageId).content.substring(
                        0,
                        30
                    )
                  }}{{
                    getMentionedMessage(mentionedMessageId).content.length > 30
                        ? "..."
                        : ""
                  }}
                  <a-button
                      icon="delete"
                      shape="circle"
                      type="link"
                      @click="mentionedMessageId = null"
                  />
                </p>
                <a-row v-if="lastMessageActions" style="margin-bottom: 12px">
                  <a-button
                      v-for="action in lastMessageActions"
                      :key="action.actionId"
                      style="margin-right: 8px"
                      type="primary"
                      @click="addAutoMessage(action)"
                  >
                    <vue-markdown class="markdown-field">
                      {{ action.title }}
                    </vue-markdown>
                  </a-button>
                </a-row>
                <a-textarea
                    v-model="messageText"
                    :allowClear="true"
                    :auto-size="{ minRows: 2, maxRows: 6 }"
                    :disabled="!config.chat"
                    :maxLength="1000"
                    placeholder="Wpisz wiadomość..."
                    @keyup.enter="addMyMessage"
                />
                <a-row>
                  <a-col :span="12"></a-col>
                  <a-col :span="12">
                    <p class="send-message-limit">
                      {{ messageText.length }} / 1000
                      <a-progress
                          :percent="Math.round((messageText.length / 1000) * 100)"
                          :showInfo="false"
                          :status="
                          Math.round((messageText.length / 1000) * 100) > 90
                            ? 'exception'
                            : 'active'
                        "
                          :strokeWidth="20"
                          :width="20"
                          style="margin-left: 6px"
                          type="circle"
                      />
                    </p>
                  </a-col>
                </a-row>
              </a-row>
            </a-col>
            <a-col
                :lg="6"
                :md="24"
                :sm="24"
                :xl="6"
                :xs="24"
                :xxl="6"
                style="padding-left: 24px"
            >
              <a-row style="text-align: center">
                <a-col :lg="24" :md="0" :sm="0" :xl="24" :xs="0" :xxl="24"
                >
                  <a-avatar :size="128">
                    <img
                        slot="icon"
                        alt="Avatar"
                        src="@/assets/brain.png"
                    /></a-avatar
                  >
                </a-col>
              </a-row>
              <a-row style="text-align: center; padding-bottom: 2em">
                <a-col :lg="24" :md="0" :sm="0" :xl="24" :xs="0" :xxl="24">
                  <h1 style="margin-bottom: 0px">Brainy</h1>
                  <p style="color: rgba(0, 0, 0, 0.35)">
                    Automatic Customer Support
                  </p>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-upload-dragger
                      v-if="config.upload"
                      :default-file-list="uploadedFileList"
                      :multiple="true"
                      :showUploadList="{ showRemoveIcon: false }"
                      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      name="file"
                      @change="handleUploadFile"
                  >
                    <p class="ant-upload-drag-icon">
                      <a-icon type="inbox"/>
                    </p>
                    <p class="ant-upload-text">Kliknij bądź upuść plik</p>
                    <p class="ant-upload-hint">
                      Aby przesłać załącznik kliknij lub upuść go w to miejsce.
                    </p>
                  </a-upload-dragger>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";
import Message from "@/components/contact/Message.vue";

const testMessages = [
  {
    id: 1,
    type: "message",
    author: "Brainy",
    side: "left",
    date: "2021-03-06 21:37:00",
    content:
        "**Witaj w systemie ConnectArk!**<br><br>Bardzo miło mi Cię widzieć! Jestem Brainy i mogę rozwiązać Twój problem. Jestem automatycznym serwisantem! Odpowiedz na parę pytań i zobaczymy co da się zrobić.",
  },
  {
    id: 4,
    type: "message",
    author: "Ja",
    side: "right",
    date: "2021-03-07 15:26:30",
    content: "Odpowiadam na poprzednią wiadomość! :)",
    mentionedMessage: 3,
  },
  {
    id: 5,
    type: "message",
    author: "Brainy",
    side: "left",
    date: "2021-03-07 15:26:30",
    content:
        "Odpowiadam na wiadomość, która jest trochę dłuższa niż mogło się wydawać! :3",
    mentionedMessage: 1,
    actions: [
      {
        actionId: 1,
        title: "Tak, jest ok! :ok:",
      },
      {
        actionId: 2,
        title: "Nie, nadal nie działa :(",
      },
    ],
  },
];

export default {
  name: "Contact",
  components: {
    VueMarkdown,
    Message,
  },
  data() {
    return {
      show: false,
      config: {
        upload: false,
        chat: true,
      },
      lastMessageActions: [],
      messageText: "",
      mentionedMessageId: null,
      messages: [],
      uploadedFileList: [
        // {
        //   uid: "1",
        //   name: "Zrzut ekranu.png",
        //   status: "done",
        //   response: "Server Error 500",
        //   showRemoveIcon: false,
        // },
      ],
      facts: {
        macAddress: {
          value: undefined
        },
        isLocalConnection: {
          value: undefined
        },
        hasAccount: {
          value: undefined,
          question: "Czy posiadasz już konto w systemie ConnectArk?",
          actions: [
            { actionId: 1, title: "Tak, posiadam konto", value: true },
            { actionId: 2, title: "Nie, nie posiadam konta", value: false },
          ],
        },
        isLoggedIn: {
          value: undefined
        },
        dormCode: {
          value: undefined
        },
        isBanned: {
          value: undefined
        },
        cableConnected: {
          value: undefined,
          question: "Czy masz podłączony kabel od gniazdka na ścianie do urządzenia?",
          actions: [
            { actionId: 1, title: "Tak, kabel jest podłączony", value: true },
            { actionId: 2, title: "Nie, nie jest podłączony", value: false },
          ],
        },
        isRouter: {
          value: undefined,
          question: "Czy masz i próbujesz zarejestrować router na stronie?",
          actions: [
            { actionId: 1, title: "Tak, posiadam router", value: true },
            { actionId: 2, title: "Nie, nie posiadam routera", value: false },
          ],
        },
        isRouterWanPort: {
          value: undefined,
          question: "Czy kabel od gniazdka na ścianie jest podłączony do portu WAN routera?",
          actions: [
            { actionId: 1, title: "Tak, kabel jest podłączony do portu WAN", value: "WAN" },
            { actionId: 2, title: "Nie, jest podłączony do LAN", value: "LAN" },
          ],
        },
        isHotSpot: {
          value: undefined,
          question: "Czy korzystasz z hotspotu z telefonu lub innego urządzenia do złożenia wniosku?",
          actions: [
            { actionId: 1, title: "Tak, korzystam z hotspotu", value: true },
            { actionId: 2, title: "Nie, nie korzystam z hotspotu", value: false },
          ],
        },
      },
      patterns: [
        {
          success: undefined,
          name: "Hotspot od kolegi",
          pattern: {
            isHotSpot: true,
            isLocalConnection: true
          },
          message: {
            type: "message",
            content: "Wyłącz Wi-Fi w ustawieniach urządzenia i spróbuj ponownie.",
            actions: [
              { actionId: 1, title: "Tak, jest ok! :ok:", value: true },
              { actionId: 2, title: "Nie, nadal nie działa :(", value: false },
            ],
          }
        },
        {
          success: undefined,
          name: "Router - port LAN",
          pattern: {
            isRouter: true,
            isRouterWanPort: "LAN"
          },
          message: {
            type: "message",
            content: "Podłącz kabel od gniazdka na ścianie do portu WAN routera i spróbuj ponownie.",
            actions: [
              { actionId: 1, title: "Tak, jest ok! :ok:", value: true },
              { actionId: 2, title: "Nie, nadal nie działa :(", value: false },
            ],
          }
        }
      ]
    };
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventRefresh);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventRefresh);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$confirm({
      title: "Czy aby na pewno chcesz opuścić formularz?",
      content: "Dane nie zostały zapisane i zostaną utracone.",
      okText: "Opuszczam",
      okType: "danger",
      cancelText: "Anuluj",
      onOk() {
        next();
      },
      onCancel() {
        next(false);
      },
    });
  },
  mounted() {
    this.$emit("loadedView");
    testMessages.forEach((message) => {
      this.addMessage(message);
    });
  },
  updated() {
    this.$nextTick(() => {
      this.scrollToBottomOfChatWindow();
    });
  },
  methods: {
    preventRefresh(event) {
      event.preventDefault();
      event.returnValue = "";
    },
    addMessage: function (message) {
      this.scrollToBottomOfChatWindow();
      if (
          (message.type === "message" && message.content.trim().length > 0) ||
          (message.type === "media" && message.mediaUrl.length > 0)
      ) {
        this.messages.push({
          id: this.messages.length + 1,
          type: message.type,
          author: message.author,
          side: message.side,
          date: message.date,
          mediaUrl: message.mediaUrl,
          content: (message.content !== undefined
                  ? message.content
                  : ""
          ).trim(),
          mentionedMessage: message.mentionedMessage,
        });
        if (message.actions && message.actions.length > 0) {
          this.config.chat = false;
          this.lastMessageActions = [];
          this.lastMessageActions = message.actions;
          console.log(message.actions);
        } else {
          this.config.chat = true;
          this.lastMessageActions = [];
        }
      }
    },
    addMyMessage: function (event) {
      if (!event.shiftKey) {
        this.addMessage({
          id: this.messages.length + 1,
          type: "message",
          author: "Ja",
          side: "right",
          date: new Date().toString(),
          content: this.messageText.trim(),
          mentionedMessage: this.mentionedMessageId,
        });
        this.mentionedMessageId = null;
        this.$nextTick(() => {
          this.messageText = "";
        });
      }
    },
    addAutoMessage: function (action) {
      this.addMessage({
        id: this.messages.length + 1,
        type: "message",
        author: "Ja",
        side: "right",
        date: new Date().toString(),
        content: action.title.trim(),
      });

      ///============================ MOCK ============================
      if (action.actionId == 1) {
        this.addMessage({
          id: this.messages.length + 1,
          type: "system",
          author: "System",
          side: "center",
          date: new Date().toString(),
          content: "Dziękujemy za skorzystanie z formularza. Miłego dnia!",
        });
        this.config.chat = false;
      }
      ///============================ END MOCK ============================
    },
    addStateComment: function () {
      this.addMessage({
        id: this.messages.length + 1,
        type: "system",
        author: "System",
        side: "center",
        date: new Date().toString(),
        content: "Chat został przejęty przez administratora.",
      });
      this.addMessage({
        id: this.messages.length + 1,
        type: "message",
        author: "Administrator",
        side: "left",
        date: new Date().toString(),
        content:
            "Witam! Widzę, że bot nie jest w stanie obsłużyć tego zgłoszenia. <br><br>**Czy chcesz skontaktować się z administratorem?**",
        actions: [
          {
            actionId: 1,
            title: "Tak, poproszę",
          },
          {
            actionId: 2,
            title: "Nie, dziękuję",
          },
        ],
      });
      this.config.upload = true;
    },
    addMediaComment: function () {
      this.addMessage({
        id: this.messages.length + 1,
        type: "media",
        mediaUrl: "",
        author: "Administrator",
        side: "left",
        date: new Date().toString(),
      });
    },
    handleUploadFile(info) {
      const status = info.file.status;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        this.$message.success(`Plik ${info.file.name} wysłany pomyślnie.`);
      } else if (status === "error") {
        this.$message.error(
            `Wysyłanie pliku ${info.file.name} nie powiodło się.`
        );
      }
    },
    getMentionedMessage(messageId) {
      return this.messages.find((message) => message.id === messageId);
    },
    mentionMessage(messageId) {
      this.mentionedMessageId = messageId;
    },
    scrollToBottomOfChatWindow: function () {
      this.$refs.end.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    },
  },
};
</script>

<style scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.send-message-limit {
  padding-top: 6px;
  text-align: right;
  font-size: 12px;
  opacity: 0.5;
}

@media screen and (min-width: 992px) {
  .v-divider {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>

<style>
.chat-message .datetime {
  display: none;
}

.chat-message:last-child .datetime {
  display: block;
  opacity: 1;
}
</style>
